import * as React from 'react';
import * as workout from './style.module.scss';
import * as main from "../../../styles/main.module.scss";

export const Workout = (
  { titleText, btnText="Записаться на пробный урок", btnAnchor="#program-free", btnHide=false }) => {
  return (
    <section className={workout.workout}>
      <div className={`container ${workout.workout__container}`}>
        <h3 className={workout.workout__title}>
          { titleText || "Регулярные тренировки — доступная профилактика возрастных изменений мозга."}
        </h3>
        <div className={workout.workout__description}>
          <p>
            Сегодня деменция стала глобальной проблемой. В мире около 44&nbsp;млн человек имеют такой диагноз.
          </p>
          <p>
            Болезнь Альцгеймера — наиболее распространенный тип деменции, состояния, при котором головной мозг
            перестает выполнять свои функции должным образом. Вызывает проблемы с&nbsp;памятью, мышлением и поведением.
          </p>
          <p>
            Деменция — это диагноз, который может поставить только врач. И&nbsp;зачастую люди путают деменцию с проблемой
            концентрации внимания.
            <span>
                <strong> Которую можно решить, если&nbsp;регулярно тренировать мозг!</strong>
            </span>
          </p>
        </div>
        {
          !btnHide &&
          <a href={btnAnchor} className={`${main.mainBtnRound} ${workout.workout__btn}`}>
            { btnText }
          </a>
        }
        <img
          src="https://fs.advance.ru/landing-pages/course/kurs-razvitiya-pamyaty/photo-krp-03.png"
          alt=""
          className={workout.workout__img}
        />
      </div>
    </section>
  );
};
